"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClaimTypeFromSubType = void 0;

var CLAIM_TYPES = __importStar(require("./types"));

var CLAIM_SUB_TYPES = __importStar(require("./subTypes"));
/**
 * Determines the appropriate claim type based on the provided subType
 *
 * @param subType - The subType of the claim
 * @param currentType - The current type of the claim (optional)
 * @returns The appropriate claim type
 */


function getClaimTypeFromSubType(subType, currentType) {
  if (!subType) {
    return currentType || CLAIM_TYPES.UNSECURED_NONPRIORITY;
  } // For MORTGAGE and AUTOMOBILE subtypes, set type to SECURED


  if ([CLAIM_SUB_TYPES.MORTGAGE, CLAIM_SUB_TYPES.AUTOMOBILE].includes(subType)) {
    return CLAIM_TYPES.SECURED;
  } // For PRIORITY debt types


  if ([CLAIM_SUB_TYPES.DOMESTIC_SUPPORT, CLAIM_SUB_TYPES.GOVERNMENT, CLAIM_SUB_TYPES.PERSONAL_INJURY, CLAIM_SUB_TYPES.RESTITUTION].includes(subType)) {
    return CLAIM_TYPES.UNSECURED_PRIORITY;
  } // Default to UNSECURED_NONPRIORITY for all other subtypes


  return CLAIM_TYPES.UNSECURED_NONPRIORITY;
}

exports.getClaimTypeFromSubType = getClaimTypeFromSubType;